// Components
import { SelectedStaffTableRow } from "./SelectedStaffTableRow";

// Material-ui imports
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export function SelectedStaffTable({ staff, order }) {
  // Responsive: treat screens below 'sm' as mobile
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <TableContainer component={Paper}>
      <Table aria-label="Select Staff">
        <TableHead>
          <TableRow>
            {isMobile ? (
              <TableCell align="center">Items</TableCell>
            ) : (
              <>
                <TableCell align="center">Add</TableCell>
                <TableCell align="center">Items</TableCell>
              </>
            )}
            <TableCell>Name (ID)</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Remove</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {staff?.map((person) => (
            <SelectedStaffTableRow
              person={person}
              order={order}
              isMobile={isMobile}
              key={person.no}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
